<template>
  <div class="chat-panel">
    <div style="position: relative;" class="container">
      
      <div class="chat-container">
        <!-- 左边侧边栏 -->
        <div class="chat-box-list">
            <div style="padding: 5px; display: flex; align-items: center;border-bottom: 1px solid #dcdee2;" class="chat-search">
              <div @click="isStoreShow = !isStoreShow" style="padding: 5px;cursor: pointer;" class="collapse-btn">    
                <Icon size="24" type="ios-options" />
              </div>
              <div @click="searchModal = true" style="padding: 5px;cursor: pointer;margin-left: 10px;" class="order-search">
                <Icon size="24" type="ios-search" />
              </div>
              <div @click="knowledgeShow" style="padding: 5px;cursor: pointer;margin-left: 10px;" class="order-search">
                <Icon size="24" type="md-book" />
              </div>
              <div @click="saleerShow" style="padding: 5px;cursor: pointer;margin-left: 10px;" class="order-search">
                <Icon size="24" type="md-contacts" />
              </div>
              <div @click="sessionRefresh" style="padding: 5px;cursor: pointer;margin-left: 10px;" class="session-refresh">
                <Icon size="24" type="md-refresh" />
              </div>
            </div>

            <div style="display: flex;" class="chat-box-side">            
              <Store v-if="isStoreShow" style="width: 20rem;background: #fff;" @updatesession="updatesession" ref="lazadaStoreElem"></Store>
              <Session style="width: 32rem" ref="sessionElem" @showChat="showChat" :sessionList="sessionList"></Session>
            </div>

        </div>
        <div v-if="currentStore.im_expiresin_text == '已过期'" class="store-expire-layer">
          <div style="display: flex;flex-direction: column;">          
            <div style="font-size: 18px;">该店铺授权已过期, 请前往授权</div>
            <div style="width: 80%;text-align: center;">            
              <Button @click="authorize" type="error">授权</Button>
            </div>
          </div>
        </div>
        <!-- 中间 -->
        <div class="chat-box">
          <div v-show="false" class="portal-bg">
            <div class="portal-text">
              <h3 data-spm-anchor-id="a1zawg.15103027.0.i2.4cf24edfcmQGQg">
                <font style="vertical-align: inherit;">
                  <font data-spm-anchor-id="a1zawg.15103027.0.i4.4cf24edfcmQGQg" style="vertical-align: inherit;">全新的消息工作站终于来了！</font></font>
              </h3>
              <p data-spm-anchor-id="a1zawg.15103027.0.i1.4cf24edfcmQGQg">
                <font style="vertical-align: inherit;">
                  <font data-spm-anchor-id="a1zawg.15103027.0.i5.4cf24edfcmQGQg" style="vertical-align: inherit;">以更有效的方式与客户交谈，以帮助您的业务更快发展！</font></font>
              </p>
            </div>
            <div class="portal-image">
              <img src="~@/static/img/chat-bg.png"></div>
          </div>
          <UserChat ref="chatElem" @emitPreviewImg="previewImgmsg" @previewshow="previewshow" @showChat="showChat"></UserChat>
        </div>

        <!-- 右边侧边栏 -->
        <div class="chat-side">
          <BuyerInfo ref="buyerInfoElem"></BuyerInfo>
          <SidePanel ref="sidePanelElem"></SidePanel>
        </div>

      </div>

      <Preview @previewhide="previewhide" v-show="ispreview" :img="previewImg"></Preview>
      <PreImgmsg @preImgmsgHide="preImgmsgHide" v-show="preImgmsgData" :img="preImgmsgData"></PreImgmsg>
      <FloatBtn @click.native="openModal"></FloatBtn>
    </div>
    <Modal
        v-model="searchModal"
        title="查询中心"
        :footer-hide="true"
        >
        <SearchCenter @sessionOpen="sessionOpen"></SearchCenter>
    </Modal>
    <!-- 知识 -->
    <Modal 
        v-model="knowledgeModal"
        title="知识"
        :footer-hide="true"
        width="80%"
        >
        <Knowledge ref="knowledgeElem"></Knowledge>
    </Modal>
    <Modal 
        v-model="saleServiceModal"
        title="售后服务"
        :footer-hide="true"
        width="80%"
        >
        <saleService ref="saleServiceElem"></saleService>
    </Modal>
  </div>
</template>
<script>
import SidePanel from "../../components/lazada/sidePanel.vue";
import BuyerInfo from "../../components/lazada/buyerInfo.vue";
import Session from "../../components/lazada/session.vue";
import Preview from "../../components/lazada/preview.vue";
import PreImgmsg from "../../components/lazada/preImgmsg.vue";
import Store from "../../components/lazada/store.vue";
import UserChat from "../../components/lazada/chat.vue";
import SearchCenter from "../../components/lazada/searchCenter.vue";
import EventBus from "@/utils/eventBus";
import RequestUtils from "@/utils/RequestUtils";
import Knowledge from "@/views/knowledge/knowledge_page.vue";
import saleService from "@/views/saleser/saleService.vue";
import FloatBtn from "@/views/components/float-btn";

import {
  ChatListUtils,
  imageLoad,
  MessageTargetType,
} from "../../../../utils/ChatUtils";
import conf from "../../conf";

export default {
  components: {
    Store,
    UserChat,
    Preview,
    PreImgmsg,
    Session,
    BuyerInfo,
    SidePanel,
    SearchCenter,
    Knowledge,
    saleService,
    FloatBtn
  },
  data() {
    return {
      isMounted: false,
      previewImg: '',
      ispreview: false,
      sessionList: [],
      showMessageBox: false,
      preImgmsgData: false,
      searchModal: false,
      knowledgeModal: false,
      saleServiceModal: false,
      isStoreShow: true
    };
  },
  computed: {
    sessionScroll() {
      if (this.isMounted) {      
        return window.innerHeight - this.$refs.lazadaStoreElem.$el.offsetHeight - 20;
      }
      return 500;
    },
    currentStore: {
      get: function () {
        return this.$store.state.lazada.currentStore;
      }
    },
    currentSession: {
      get: function() {
        let seller_id = this.$store.state.lazada.currentStore.seller_id;
        return this.$store.state.lazada.currentSessionData[seller_id];
      }
    },
    sessionData: {
      get: function() {
        let seller_id = this.$store.state.lazada.currentStore.seller_id;
        if (this.$store.state.lazada.sessionData[seller_id]) {        
          return this.$store.state.lazada.sessionData[seller_id];
        }
        return [];
      },
    }
  },
  methods: {
    // 店铺授权
    authorize () {
      let param = new FormData();
      param.set("appcate", 'IM');

      RequestUtils.request(conf.getAuthUrl('lazada'), param)
      .then(data => {      
        window.open(data.url,"Add Account", "width=1024,height=600,toolbar=no,location=no,directories=no,status=no,menubar=yes,scrollbars=yes");
      })
    },
    initData() {
      let self = this;
      let param = new FormData();
      param.set("connector", 'lazada');
      RequestUtils.request(conf.getStoresUrl(), param)
      .then(function (data) {
        if (data.length > 0) {
          self.$store.commit("lazada/setStoreList", data);
          RequestUtils.webSocketSend('sessionList', {
            'platform': 'lazada'
          });
        }
      })

    },
    initSession(store) {
      let self = this;
      let param = new FormData();
      param.set("store_id", store.id);
      param.set("connector", 'lazada');

      self.$store.commit("lazada/setCurrentStore", store);
      RequestUtils.request(conf.getSessionList(), param)
      .then(data => {
        data.store_id = store.id;
        data.seller_id = store.seller_id;
        let session_list = [];
        for (let i=0; i<data.session_list.length; i++) {
          if (data.session_list[i].last_message_time) {
            session_list.push(data.session_list[i]);
          }
        }
        data.session_list = session_list;
        self.$store.commit("lazada/setSessionData", data);
      })
    },
    updatesession () {
      let seller_id = this.$store.state.lazada.currentStore.seller_id;
      this.sessionList = this.$store.state.lazada.sessionData[seller_id].session_list;
    },
    showChat: function(session) {
      let self = this;
      // session.store_id = this.sessionData.store_id;
      // self.currentSession = session;
      if (this.currentStore.id != session.store_id) {
        for (var i=0; i<this.$store.state.lazada.storeList.length; i++) {
          if (this.$store.state.lazada.storeList[i].id == session.store_id) {
            this.$store.commit("lazada/setCurrentStore", this.$store.state.lazada.storeList[i]);
            break;
          }
        }
      }
      self.$store.commit("lazada/setCurrentSessionData", session);
      this.$refs.chatElem.getHistoryMessage();
      this.$refs.sidePanelElem.getOrder();
      this.$refs.buyerInfoElem.getBuyerInfo();
    },
    sessionOpen: function (session) {
      this.showChat(session);
      this.searchModal = false;
    },
    previewshow: function (data) {
      console.log(data);
      this.previewImg = data;
      this.ispreview = true;
    },
    previewhide: function () {
      this.ispreview = false;
    },
    previewImgmsg (item) {
      this.preImgmsgData = item;
    },
    preImgmsgHide () {
      this.preImgmsgData = false;
    },
    showSearchChat: function(chat) {
      let self = this;
      self.$store.commit("lazada/resetUnRead");
      self.currentChat = chat;
      // 每次滚动到最底部
      self.$nextTick(() => {
        imageLoad("message-box");
      });
      ChatListUtils.resetChatList(
        self,
        chat,
        conf.getHostUrl(),
        MessageTargetType.FRIEND
      );
    },
    knowledgeShow() {
      this.knowledgeModal = true;
      this.$refs.knowledgeElem.getKnowCate();
    },
    saleerShow() {
      this.saleServiceModal = true;
      this.$refs.saleServiceElem.refresh();
    },
    openModal() {
      EventBus.$emit('openBuyerList');
    },
    // 刷新session列表
    sessionRefresh() {
      RequestUtils.webSocketSend('sessionList', {
        'platform': 'lazada'
      });
      this.$Message.loading({
          content: '刷新中...',
          duration: 5
      });
    }
  },
  activated: function() {
    let self = this;
    // 每次滚动到最底部
    self.$nextTick(() => {
      imageLoad("message-box");
    });
  },
  mounted: function() {
    let self = this;
    this.isMounted = true;
    this.initData();
    EventBus.$on('openSession', args => {
      this.saleServiceModal = false;
      this.sessionOpen(args);
    })
    EventBus.$on('copyToChat', (args) => {
      this.knowledgeModal = false;
      this.$refs.chatElem.copyToChat(args);
    })
    window.addEventListener('message', function(e) {
        var data = e.data;
        if (data.platform == 'lazada') {
          if (data.event == 'refresh') {                
            if (data.store) {
              self.$store.commit("lazada/setStoreAttr", data.store);
              self.$store.commit("lazada/setCurrentStore", data.store);
            }
          } else if (data.event == 'error') {
              self.$Message.error(data.message);
          } else if (data.event == 'success') {
              self.$Message.success(data.message);
          }
        }
    })  
  }
};
</script>
<style lang="scss" scoped>
@import "@/static/styles/theme";

.ivu-tabs-content {
  height: 100%;
}
.container {
  width: 100%;
}
.chat-container {
  display: flex;
  width: 100%;
  height: 100%;
}
.ivu-divider-horizontal {
  margin: 0px;
}
.chat-panel {
  width: 100%;
  background-color: $color-light-gray;
  height: 100%;
  display: flex;
  flex-direction: row;
  padding-right: 1rem;

  .chat-box {
    flex: 1;
    background-color: $color-box-bg;
    display: flex;
    flex-direction: column;
    position: relative;
  }

  .chat-box-list {
    height: 100%;
    display: flex;
    flex-direction: column;

    .search-box {
      margin: 1.5rem;
      width: 19rem;
    }
  }

  .chat-side {
    height: 100%;
    width: 22%;
    display: flex;
    flex-direction: column;
  }
}

.portal-bg {
  display: flex;
  align-items: center;
  position: relative;
  padding-top: 10%;
  flex-direction: column;
  flex-grow: 1;

  .portal-text {
    color: #4f566a;
    font-family: Roboto;
    text-align: center;
    font-size: 120%;
    min-width: 500px;

    h3 {
      line-height: 30px;
      font-size: 150%;
      font-weight: 700;
    }
    p {
      font-size: inherit;
      line-height: 22px;
      font-weight: 400;
    }
  }
  .portal-image {
    margin-top: 32px;
    padding: 24px 32px;
    background-color: #fff;
    border-radius: 12px;

    img {
      width: 600px;
    }
  }
}
</style>
